export const roles = [
  { ru: 'Оператор', en: 'Operator', code: 'OPERATOR' },
  { ru: 'Курьер', en: 'Courier', code: 'COURIER' }
]
